"use strict";

var _classCallCheck = require("/opt/build/repo/.yarn/cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Point = void 0;

var Point = function Point(position, particle) {
  _classCallCheck(this, Point);

  this.position = position;
  this.particle = particle;
};

exports.Point = Point;